// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import Button from '@mui/material/Button'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import Select from '../../../../../common/select/Select'
import { i18n } from '../../../../index'
import { fetchLinkTags } from '../../../guidelinesAndLinks/components/LinkTags/queries'
import { fetchIntroductionLinks, updateIntroductionLink } from '../../queries'
import css from './UpdateDialog.css'

const updateCache = (cache, { data: { updateIntroductionLink } }) => {
  const { introductionLinks } = cache.readQuery({
    query: fetchIntroductionLinks,
  })
  cache.writeQuery({
    query: fetchIntroductionLinks,
    data: {
      introductionLinks: [
        ...introductionLinks.map((introductionLink) => {
          console.log(updateIntroductionLink)
          return introductionLink.id === updateIntroductionLink.id ? updateIntroductionLink : introductionLink
        }),
      ],
    },
  })
}

class UpdateDialog extends React.Component {
  constructor() {
    super()
    this.state = {
      id: '',
      fileName: '',
      href: '',
      selectedLinkTag: '',
    }
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props

    if (data !== prevProps.data) {
      this.setState({ ...data, selectedLinkTag: (data.linkTags ?? [])[0]?.id })
    }
  }

  onCancel = () => {
    this.setState({
      fileName: '',
      href: '',
      selectedLinkTag: '',
    })
    this.props.close()
  }
  onSubmit = (e, onMutate) => {
    e.preventDefault()
    const { id, fileName, href, selectedLinkTag } = this.state
    onMutate({
      variables: {
        id,
        fileName,
        href,
        linkTagId: selectedLinkTag,
      },
      update: updateCache,
    })
    this.props.close()
  }

  onLinkTagSelected = (linkTagOption) => {
    this.setState({
      ...this.state,
      selectedLinkTag: linkTagOption.value,
    })
  }

  render() {
    const { isOpen } = this.props
    const { fileName, href, selectedLinkTag } = this.state
    return (
      <Dialog open={isOpen} onBackdropClick={this.onCancel}>
        <DialogTitle>{i18n.t('admin.introduction.updateDialogTitle')}</DialogTitle>

        <DialogContent>
          <Query query={fetchLinkTags}>
            {({ loading, data }) => (
              <Mutation mutation={updateIntroductionLink}>
                {(onMutate) => (
                  <form onSubmit={(e) => this.onSubmit(e, onMutate)}>
                    <TextField
                      autoFocus
                      required
                      fullWidth
                      label={i18n.t('admin.introduction.fileName')}
                      placeholder={i18n.t('admin.introduction.fileNamePlaceholder')}
                      className={css.input}
                      value={fileName}
                      onChange={(e) =>
                        this.setState({
                          fileName: e.target.value,
                        })
                      }
                    />

                    <TextField
                      required
                      fullWidth
                      label={i18n.t('admin.introduction.link')}
                      placeholder={i18n.t('admin.introduction.linkPlaceholder')}
                      className={css.input}
                      value={href}
                      onChange={(e) =>
                        this.setState({
                          href: e.target.value,
                        })
                      }
                    />

                    <Select
                      onChange={this.onLinkTagSelected}
                      value={selectedLinkTag}
                      options={data?.linkTags?.map((linkTag) => ({ label: linkTag.name, value: linkTag.id })) ?? []}
                    />

                    <DialogActions>
                      <Button type='button' onClick={this.onCancel}>
                        {i18n.t('buttons.cancel')}
                      </Button>
                      <Button type={'submit'} color={'primary'}>
                        {i18n.t('buttons.save')}
                      </Button>
                    </DialogActions>
                  </form>
                )}
              </Mutation>
            )}
          </Query>
        </DialogContent>
      </Dialog>
    )
  }
}

export default UpdateDialog
